import { Hero } from "@/components/sections/Hero";
import { SearchSection } from "@/components/sections/SearchSection";
import { FeaturedProperties } from "@/components/sections/FeaturedProperties";
import { AreasGrid } from "@/components/sections/AreasGrid";
import { DeveloperStrip } from "@/components/sections/DeveloperStrip";
import { Practice } from "@/components/sections/Practice";
import { InsightsPreview } from "@/components/sections/InsightsPreview";
import { useSeo } from "@/hooks/useSeo";

export function HomePage() {
  useSeo({
    title: "Hive Homes | Luxury Property for Sale & Rent in Dubai",
    description:
      "Buy, rent or invest in Dubai property with Hive Homes — a boutique real estate brokerage across Downtown, Business Bay, JVC, Tilal Al Ghaf and more. Speak to an advisor today.",
  });

  return (
    <>
      <Hero />
      <SearchSection />
      <FeaturedProperties />
      <DeveloperStrip />
      <AreasGrid />
      <Practice />
      <InsightsPreview />
    </>
  );
}
